/**
 * Reconnect delay: exponential from half a second to thirty, with "full
 * jitter" — a random delay between zero and the ceiling.
 *
 * The jitter is the important part. After a deploy every browser in a company
 * loses its connection in the same second; without jitter they would all come
 * back in the same second too, every time (ADR 0005).
 */
export const BACKOFF_BASE_MS = 500;
export const BACKOFF_MAX_MS = 30_000;

export function backoffDelay(attempt: number, random: () => number = Math.random): number {
  const ceiling = Math.min(BACKOFF_MAX_MS, BACKOFF_BASE_MS * 2 ** Math.max(0, attempt));
  return Math.floor(random() * ceiling);
}
